import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'La Primera Clase Perfecta',
    desc: 'El guion exacto para convertir alumnos nuevos en clientes fieles.',
    image: 'https://cdn.magicpatterns.com/uploads/btfgMjpfUHn6BQHYojXopx/5a7dc82e-eabd-4439-996d-b5e6d7e58491-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: 'El Diccionario de Cues',
    desc: 'Las frases precisas para corregir rápido y sonar profesional.',
    image: 'https://cdn.magicpatterns.com/uploads/4S1UuG4tckEEYPykDfP88m/564417f0-ead1-46c0-ba0e-2179894af623-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'Sistema Progreso Visible',
    desc: 'Método para registrar y mostrar los avances de tus alumnos.',
    image: 'https://cdn.magicpatterns.com/uploads/fEJoNgxXsB9G8YsKWQPATm/069f960d-7b38-4504-b332-929c11fefe96-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: 'Clases Grupales sin Caos',
    desc: 'Cómo gestionar niveles mixtos sin perder el ritmo.',
    image: 'https://cdn.magicpatterns.com/uploads/6Fe4JDjE775PLHQ1oJUnoh/cced5e09-5094-4432-8622-ed051bd2ab1b-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'Kit Anti-Cancelaciones',
    desc: 'El protocolo para proteger tu agenda y tus ingresos.',
    image: 'https://cdn.magicpatterns.com/uploads/oraLwFrNFDrKhqHAwC6r4v/c7da6719-db83-4620-9b10-1626c36f22b2-mockup.webp'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden pt-[010px] pb-[010px]" data-id="element-27">
      <div className="absolute top-20 right-0 w-96 h-96 bg-pilates-sage/15 rounded-full blur-3xl pointer-events-none" data-id="element-28"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-29"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-30">
        <div className="text-center mb-14" data-id="element-31">
          <div className="bg-pilates-rose/15 text-pilates-rose-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em] flex items-center gap-2 w-fit mx-auto" data-id="element-32">
            <Gift className="w-4 h-4" data-id="element-33" /> 5 BONOS INCLUIDOS
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-34">
            Y además, recibe{' '}
            <span className="italic text-pilates-rose" data-id="element-35">5 bonos de lujo</span>
          </h2>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-36">
            Recursos exclusivos que transformarán tu día a día — incluidos
            gratis con tu pack.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-37">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-pilates-sage/15 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-38">
              <div className="relative mb-5 overflow-hidden rounded-xl bg-gradient-to-br from-pilates-cream to-pilates-soft aspect-square" data-id="element-39">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-40" />
                <div className="absolute top-3 left-3 bg-pilates-rose text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-41">
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-pilates-sage-dark text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-42">
                  🎁 Gratis
                </div>
              </div>
              <h3 className="font-display font-semibold text-pilates-dark text-lg leading-tight mb-2" data-id="element-43">
                {bonus.title}
              </h3>
              <p className="text-pilates-slate text-sm leading-relaxed" data-id="element-44">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-pilates-sage-dark to-pilates-dark rounded-2xl p-6 shadow-md flex flex-col items-center justify-center text-center text-white" data-id="element-45">
            <Gift className="w-12 h-12 text-pilates-cream mb-3" data-id="element-46" />
            <p className="text-white/80 text-sm uppercase tracking-wider mb-2" data-id="element-47">
              Todo incluido en
            </p>
            <p className="font-display text-3xl font-semibold text-pilates-cream mb-2" data-id="element-48">
              el Pack 6 en 1
            </p>
            <p className="text-white/75 text-sm leading-relaxed" data-id="element-49">
              Los 5 bonos son gratis con tu compra hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}